import React from "react";
import httpClient from "../../axios";
import Nav from "../../Components/Nav";

const Setup = () => {
	const http = httpClient();
	return (
		<div style={{ padding: "1rem" }}>
			<div className="ln-en">
				<title>
					CFAA Verification Inspection Simulator - Setup Instructions
				</title>
				<h1>CFAA Verification Inspection Simulator - Instructions</h1>
				<p>
					Thank you for purchasing the CFAA Verification Inspection
					Simulator! Please follow the instructions below to get
					started:
				</p>
				<ol>
					<li>
						Navigate to{" "}
						<a
							href="https://cfaa.vrts.ca/simulation"
							target="_blank"
						>
							https://cfaa.vrts.ca/simulation
						</a>
					</li>
					<li>
						Once the application fully loads, you'll be prompted to
						enter your email.
					</li>
					<li>
						Type in the same email you used for purchasing the
						product, and click <b>Proceed</b>.
					</li>
					<li>
						Select <b>Request New Password</b>.
					</li>
					<li>
						Check your email's inbox (and spam folder if it's not
						there) for an email containing your verification PIN.
					</li>
					<li>
						Enter the PIN into text box in the application and
						select <b>Request New Password</b> again.
					</li>
					<li>
						If the PIN is accepted, you'll be prompted to create
						your own password.
					</li>
					<li>
						Enter your password, and enter it again to confirm it
						and select <b>Reset Password</b>
					</li>
					<li>
						That's it! You can now log in any time to resume your
						progress.
					</li>
				</ol>
			</div>
			<br /> <br /> <br />
			<div className="ln-fr">
				<title>
					Simulateur d'inspection de vérification ACAI - Instructions
				</title>
				<h1>
					Simulateur d'inspection de vérification ACAI - Instructions
				</h1>
				<p>
					Merci d’avoir acheté le Simulateur d’inspection de
					vérification ACAI! Veuillez suivre les étapes ci-dessous
					pour commencer :
				</p>
				<ol>
					<li>
						Naviguez vers &nbsp;
						<a
							href="https://cfaa.vrts.ca/simulation"
							target="_blank"
						>
							https://cfaa.vrts.ca/simulation
						</a>
					</li>
					<li>
						Une fois que l’application est complètement chargée,
						vous serez invité(e) à entrer votre adresse courriel.
					</li>
					<li>
						Saisissez
						<b>
							la même adresse courriel que celle utilisée lors de
							votre achat
						</b>
						, puis cliquez sur <b>Continuer</b>.
					</li>
					<li>
						Sélectionnez <b> Demander un nouveau mot de passe </b>
					</li>
					<li>
						Consultez votre <b>boîte de réception</b> (et votre
						&nbsp;
						<b>courrier indésirable </b> au besoin) afin de trouver
						le courriel contenant votre &nbsp;
						<b>code PIN de vérification </b>.
					</li>
					<li>
						Entrez le code PIN dans la zone de texte de
						l’application, puis sélectionnez de nouveau
						<b> Demander un nouveau mot de passe </b>.
					</li>
					<li>
						Si le code PIN est accepté, vous serez invité(e) à créer
						votre <b>mot de passe</b>.
					</li>
					<li>
						Saisissez votre mot de passe, puis saisissez-le une
						seconde fois pour le confirmer et sélectionnez &nbsp;
						<b>Réinitialiser le mot de passe </b>.
					</li>
					<li>
						Et voilà ! Vous pouvez maintenant ouvrir une session en
						tout temps pour reprendre votre progression.
					</li>
				</ol>
				<p></p>
			</div>
		</div>
	);
};

export default Setup;
